<ng-container *ngIf="block">
  <div class="position-relative">
    <div (click)="viewContainer = true"
      class="custom-select text-neutral-50 ls-p position-relative d-flex align-items-center" 
      [ngClass]="{'border-active': valueSelected, 'firstInput': firstInput, 'lastInput': lastInput, 'oneInput': firstInput && lastInput, 'otherInput': !firstInput && !lastInput}">
      <p class="m-0 text-custom" [innerHTML]="valueSelected ? valueSelected : this.block['label_' + this.helpersService.langCodeApi]"></p>
    </div>
    <div *ngIf="viewContainer" class="custom-select__option text-neutral-10 position-absolute d-flex flex-column bg-white">
      <p class="m-0 cursor-pointer text-hover" [innerHTML]="'GENERAL.ALL' | translate" (click)="selectVal(''); viewContainer = false"
        [ngClass]="{'text-selected': valueSelected === ''}">
      </p>
      <ng-container *ngFor="let opt of options">
        <p class="m-0 cursor-pointer text-hover" [innerHTML]="opt.name" (click)="selectVal(opt.name); viewContainer = false"
          [ngClass]="{'text-selected': valueSelected === opt.name}">
        </p>
      </ng-container>
    </div>
    <div class="position-absolute icon">
      <i class="fa-solid fa-angle-down text-success" aria-hidden="true"></i>
    </div>
  </div>
</ng-container>